module.exports = __webpack_public_path__ + "static/img/dgf5.b99317f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/dgf5.jpg
// module id = U1nM
// module chunks = 0